import {
    can_trial, generateAppMarketInitialState,
    // checkLoginStatus,
    getAppList,
    // getEnterpriseList,
    getEnterpriseLoginUrl,
    // getLoginStatus,
    // getTenantPermission,
    // getUserInfo,
    trial,
} from '../api'

import {
    setPayModalAppId,
    setPayModalAppList, setPayModalItemName,
    // setPayModalCategories,
    setPayModalLoading,
    setPayModalOrderType,
    setPayModalVisible, setRecordModalInitialState, setRecordModalShow, setRecordModalShowExtra,
    // setRecordModalInitialState,
    // setRecordModalShow,
    // setRecordModalShowExtra,
} from '../store'

import {showAdminPermissionModal} from "../components/AdminPermissionModal.jsx";
import {ENTERPRISE_BASE_URL} from "../constants";

const getOperatePermission = (initialState) => {
    if (initialState?.staff && !initialState.staff.is_super_admin) {
        showAdminPermissionModal(initialState.admin_name)
        return false
    }
    return true
}

// export function goLogin(base_url, editType) {
//     window.location.href = `${base_url}/enuser/login?callback=${encodeURIComponent(
//         window?.location?.href
//     )}`
// }

export function goLogin(base_url, editType) {
    const currentUrl = new URL(window?.location?.href);
    if (editType) {
        currentUrl.searchParams.set('editType', editType);
    }

    const callback = encodeURIComponent(currentUrl.toString());

    window.location.href = `${base_url}/enuser/login?callback=${callback}`;
}


/**
 *  产品跳转处理
 * @param product_key
 * @param type
 * @param self
 */
export async function toProductDetail(product_key, type, self) {
    const {data} = await getEnterpriseLoginUrl({
        values: {product_key},
    })
    if (data.url) {
        if (!type) return window.open(data.url, self ? '_self' : '_blank')
        const currentUrl = new URL(data.url)
        currentUrl.searchParams.append('type', type)
        window.open(currentUrl.toString(), self ? '_self' : '_blank')
    }
}

/**
 *  产品试用
 * @param product_key
 * @param type
 * @param self
 */
export async function toProductTrial(product_key, type, self) {
    await trial({
        values: {
            product_key,
        },
    })
    await toProductDetail(product_key, type, self)
}

export const handlePay = async (
    type,
    initialState,
    dispatch,
    id,
    itemName
) => {
    if (!getOperatePermission(initialState)) return
    if (itemName) dispatch(setPayModalItemName(itemName))
    dispatch(setPayModalAppId(id || ""))
    setTimeout(() => {
        dispatch(setPayModalVisible(true))
        dispatch(setPayModalOrderType(type))
    })
}

// 接待工作台订购
export const toOrder = (
    product_key,
    initialState,
    dispatch,
    type,
    self
) => {
    if (!getOperatePermission(initialState)) return
    dispatch(setPayModalLoading(true))
    toProductDetail(product_key, type, self)
        .then(() => {
            // window.location.reload()
        })
        .finally(() => {
            dispatch(setPayModalLoading(false))
        })
}

// 去留资
export const toRecordInfo = (
    type,
    initialState,
    dispatch,
    source = '应用广场'
) => {
    if (!(initialState?.loginStatus === true)) {
        return goLogin(ENTERPRISE_BASE_URL)
    }
    dispatch(setRecordModalInitialState(initialState))
    dispatch(setRecordModalShow(true))
    dispatch(
        setRecordModalShowExtra({
            source,
            editType: type,
        })
    )
}
export const toTrial = async (
    product_key,
    initialState,
    dispatch,
    type,
    self,
    notReload
) => {
    if (!getOperatePermission(initialState)) return
    dispatch(setPayModalLoading(true))
    const result = await can_trial({
        values: {
            product_key,
        },
    })
    if (result?.can_trial) {
        try {
            await toProductTrial(product_key, type, self)
            const {products: appList} = await getAppList()
            dispatch(setPayModalAppList(appList))
            dispatch(setPayModalLoading(false))
            if (!notReload) {
                window.location.reload()
            }
        } finally {
            dispatch(setPayModalLoading(false))
        }
    } else {
        toProductDetail(product_key).finally(() => dispatch(setPayModalLoading(false)))
    }
}

export function getCurrentKey(path) {
    const urlWithoutQuery = path.split('?')[0];
    const regex = /\/app\/detail\/([^\/]+)/;
    const match = urlWithoutQuery.match(regex);
    if (match) {
        const field = match[1];
        const parts = field.split('__');
        if (parts.length > 1) {
            return {
                product_key: parts[0].replace(/^app_/, ""),
                app_key: parts.slice(1).join('__')
            }
        } else {
            return {
                product_key: field.replace(/^app_/, ""),
                app_key: null
            }
        }
    }
    return {};
}

export function getPaidInfo() {
    const info = {}
    const fields = ["paid_app_id", "paid_source_type"]
    for (const field of fields) {
        info[field] = localStorage.getItem(field)
        localStorage.removeItem(field)
    }
    return info
}

export function useButtonStatus() {
    const {useState, useEffect} = React
    const [loading, setLoading] = useState(true)
    const [buttonStatus, setButtonStatus] = useState(null)

    useEffect(() => {
        async function fetchData() {
            try {
                const initialState = await generateAppMarketInitialState()
                const allProducts = await getAppList()
                const itemData = JSON.parse(document.querySelector("#app-hub-pc-buttons")?.dataset?.item || {})

                const {product_key, app_key} = getCurrentKey(window.location.pathname)
                const isLoggedIn = initialState?.loginStatus === true
                console.error('当前登录状态', isLoggedIn)

                const button_key = app_key || product_key
                let hasOrder = isLoggedIn
                let showTrialButton = isLoggedIn
                let showBuyButton = isLoggedIn
                let showRenewableButton = isLoggedIn
                let showAdditionalPurchaseButton = isLoggedIn

                const currentProduct = allProducts?.products?.find(
                    (product) => product?.product?.product_key === product_key
                )
                const productStatus = currentProduct?.product?.status
                const integralProducts = ['xdtech_service_platform']
                const isIntegralProduct = integralProducts.includes(product_key)

                const currentApp = allProducts?.apps?.find(
                    (plugin) => plugin.plugin_key === app_key
                )

                const productNotOrder = productStatus === 0 || productStatus === 2

                if (!app_key) {
                    const isProductSubscriptionRenewable =
                        productStatus === 1 &&
                        currentProduct?.app_instance?.support_online_order

                    if (isIntegralProduct) {
                        showTrialButton &&= productStatus === 0
                        showBuyButton &&= productNotOrder
                        showRenewableButton &&= productStatus === 1
                    } else {
                        showTrialButton &&=
                            productStatus === 0 &&
                            currentProduct?.app_instance?.support_trial_order
                        showBuyButton &&=
                            productNotOrder &&
                            currentProduct?.app_instance?.support_online_order
                        showRenewableButton &&= isProductSubscriptionRenewable
                    }

                    showAdditionalPurchaseButton &&=
                        isProductSubscriptionRenewable &&
                        currentProduct?.app_instance?.billed_type === 2

                    hasOrder &&= !productNotOrder
                } else {
                    const appNotOrder =
                        currentApp?.order_status === 0 || currentApp?.order_status === 2
                    const appIsActiveAndSupportsOnlineOrdering =
                        currentApp?.order_status === 1 && currentApp?.support_online_order
                    const appExpiryTimeBeforeProductExpiryTime = moment
                        .unix(currentApp?.expired_at)
                        .isBefore(moment.unix(currentProduct?.product?.expire_ts))

                    showTrialButton &&=
                        currentApp?.order_status === 0 &&
                        currentApp?.support_trial_order
                    showBuyButton &&=
                        appNotOrder &&
                        currentApp?.support_online_order &&
                        !productNotOrder
                    showRenewableButton &&=
                        appIsActiveAndSupportsOnlineOrdering &&
                        appExpiryTimeBeforeProductExpiryTime
                    showAdditionalPurchaseButton &&=
                        appIsActiveAndSupportsOnlineOrdering &&
                        currentProduct?.product?.expire_ts &&
                        currentApp?.billed_type === 2

                    hasOrder &&= !appNotOrder
                }
                if (!isLoggedIn) {
                    showTrialButton = itemData?.data?.support_trial_order
                    showBuyButton = itemData?.data?.support_online_order
                    if (isIntegralProduct){
                        showTrialButton = true
                        showBuyButton = true
                    }
                }

                setButtonStatus({
                    isLoggedIn,
                    showTrialButton,
                    showBuyButton,
                    showRenewableButton,
                    showAdditionalPurchaseButton,
                    hasOrder,
                    button_key,
                    currentProduct,
                    currentApp,
                    isIntegralProduct,
                    product_key,
                    app_key,
                    initialState,
                    productNotOrder,
                    itemData
                })
            } catch (err) {
                console.error('useButtonStatus error:', err)
            } finally {
                setLoading(false)
            }
        }

        fetchData()
    }, [])

    return {...buttonStatus, loading}
}